import { user } from '../constants';
import userService from '../services/user';

export const saveUserToken = token => ({
  type: user.SAVE_USER_TOKEN,
  token
});

export const saveUserProfile = profile => ({
  type: user.SAVE_USER_PROFILE,
  profile
});

const fetchUserProfileRequest = () => ({
  type: user.FETCH_USER_PROFILE_REQUEST
});

const fetchUserProfileSuccess = profile => ({
  type: user.FETCH_USER_PROFILE_SUCCESS,
  profile
});

const fetchUserProfileFailure = error => ({
  type: user.FETCH_USER_PROFILE_FAILURE,
  error
});

export const fetchUserProfile = () => async (dispatch, getState) => {
  dispatch(fetchUserProfileRequest());

  let res;

  const token = getState().user.accessToken;

  try {
    res = await userService.getUserProfile(token);

    if (typeof res === 'object') {
      if (res.status === 200) {
        const { Admin: isAdmin, Token: token, MaxLicenseDay: maxLicenseDay } = res.data.Result;
        const currentProfile = getState().user.profile;

        dispatch(
          fetchUserProfileSuccess({
            ...currentProfile,
            isAdmin,
            token,
            maxLicenseDay
          })
        );
      } else {
        const { status, statusText, data } = res.response;

        dispatch(
          fetchUserProfileFailure({
            response: res,
            status,
            statusText,
            data
          })
        );
      }
    }
  } catch (e) {
    dispatch(fetchUserProfileFailure(e));
  }

  return res;
};

export const userLogin = () => ({
  type: user.USER_LOG_IN
});

export const userLogout = () => ({
  type: user.USER_LOG_OUT
});

export const checkEmailValidity = isEmailValid => ({
  type: user.CHECK_EMAIL_VALIDITY,
  isEmailValid
});
